/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type VerticalType = "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
export type PdpSharedIconBubblePinterest_item = {
    readonly title: string | null;
    readonly pdpURL: string | null;
    readonly vertical: VerticalType | null;
    readonly classification: {
        readonly categories: ReadonlyArray<{
            readonly precedence: number | null;
            readonly category: {
                readonly name: string | null;
                readonly browseUrl: string | null;
            } | null;
        } | null> | null;
    } | null;
    readonly photos: ReadonlyArray<{
        readonly largePath: string | null;
    } | null> | null;
    readonly " $refType": "PdpSharedIconBubblePinterest_item";
};
export type PdpSharedIconBubblePinterest_item$data = PdpSharedIconBubblePinterest_item;
export type PdpSharedIconBubblePinterest_item$key = {
    readonly " $data"?: PdpSharedIconBubblePinterest_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedIconBubblePinterest_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedIconBubblePinterest_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "pdpURL",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "vertical",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "classification",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemClassification",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "categories",
          "storageKey": null,
          "args": null,
          "concreteType": "ItemCategory",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "precedence",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "category",
              "storageKey": null,
              "args": null,
              "concreteType": "Category",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "name",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "browseUrl",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "photos",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemPhoto",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "largePath",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = 'cd75d7bafc86af106241608205487438';
export default node;
